import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var NumberInputCss = i`
  :host {
    font-family: var(--isceco-font);
    display: block;
  }

  :host(.error) input {
    outline: 2px solid var(--isceco-color-red-500);
  }

  :host(:not(.error)) #message {
    display: none;
  }

  :host(.changed) input {
    background-color: var(--isceco-color-yellow-100);
  }

  #message {
    margin: 8px 0 0;
    font-weight: normal;
    color: var(--isceco-color-red-500);
    font-size: 0.875rem;
  }

  .label-wrapper {
    display: block;
    margin-bottom: 4px; 
  }
  
  label {
    font-weight: bold;
    color: var(--isceco-color-black-500);
  }

  input {
    -moz-appearance: textfield;
    font: inherit;
    text-align: inherit;
    box-sizing: border-box;
    height: 48px;
    border-radius: 4px;
    background-color: var(--isceco-color-white-500);
    box-shadow: none;
    padding: 0 10px;
    border: 1px solid var(--isceco-color-grey-700);
    color: var(--isceco-color-grey-900);
    flex: 1;
    width: 100%;
  }

  input::placeholder {
    color: var(--isceco-color-grey-300);
    opacity: 1;
  }

  input:hover {
    border-color: var(--isceco-color-blue-500);
  }

  input:active, input:focus, input:focus-visible {
    border-color: var(--isceco-color-blue-500);
    outline-color: var(--isceco-color-blue-500);
  }

  input:disabled {
    border-color: var(--isceco-color-grey-300);
    color: var(--isceco-color-grey-300);
    cursor: not-allowed;
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
   -webkit-appearance: none;
   margin: 0;
  }

  .inline {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .inline > .label-wrapper {
      margin-right: var(--isceco-space-200);
      margin-bottom: 0;
  }

  /* readonly */

  .readonly > .label-wrapper > span {
    color: var(--isceco-color-black-500);
    font-weight: bold;
  }

  .readonly > p {
    flex-grow: 1;
    color: var(--isceco-color-black-500);
    margin: 0;
    min-height: 48px;
    padding-top: 10px;
    box-sizing: border-box;
  }

  .readonly.inline > p {
    display: flex;
    align-items: center;
    padding-top: 0;
  }
`;
export { NumberInputCss as default };
